import React, { Component } from 'react';
import { Provider, connect } from 'react-redux';
import * as actions from 'actions/users';
import VendorRequest from 'containers/VendorRequest';
import Navigation from 'containers/Navigation';
import Dashboard from 'containers/Dashboard';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import styled from 'styled-components';
import Loading from 'components/loading';
import Login from 'containers/Login';
import QuestionnaireManagement from 'containers/Manage-Questionnaire/QuestionnaireManagement';
import Questionnaire from 'containers/Questionnaire/Questionnaire';
import Sidebar from 'components/navigation/Sidebar';
import AdminManagement from 'containers/Manage-Admin/AdminManagement';
import ManageVendorRequests from 'containers/Manage-Requests/ManageVendorRequests';
import ManageVendorRequest from 'containers/Manage-Requests/ManageVendorRequest';
import AuthRedirect from 'containers/AuthRedirect';
import Reports from 'containers/Reports';
import ManageUsers from 'containers/Users/ManageUsers';
import ManageChildUsers from 'containers/Users/ManageChildUsers';
import ManageVendors from 'containers/Manage-Vendors/ManageVendors';
import ManageVendorDetails from 'containers/Manage-Vendors/ManageVendorDetails';
import requireAuth from 'utils/requireAuth';
import Permissions from 'utils/permissions';
import ManageRenewals from 'components/renewals/manage-renewals';
import RenewalDetails from 'components/renewals/renewal-details';
import DialogSessionWrapper from 'components/DialogSessionWrapper';

class App extends Component {
  state = {
    intervalExpiryCheckID: null,
  };
  componentDidMount() {
    this.props.fetchAppUser();
  }

  //Function triggered by logout button to clear the interval running
  clearIntervalOnLogout = () => {
    //clearinterval with id from state
    clearInterval(this.state.intervalExpiryCheckID);
  };

  //Get the running interval id on pop mount
  getIntervalID = intervalExpiryCheckID => {
    if (intervalExpiryCheckID) {
      this.setState({ intervalExpiryCheckID: intervalExpiryCheckID });
    }
  };

  render() {
    if (this.props.isFetching) return <Loading size={200} />;
    if (
      !this.props.appUser ||
      (!this.props.appUser.ssoUser && this.props.appUser.passwordReset === 1)
    ) {
      return (
        <Provider store={this.props.store}>
          <Router basename={process.env.REACT_APP_BASENAME || '/'}>
            <Switch>
              <Route
                exact
                path="/auth-redirect"
                component={AuthRedirect}
                {...this.props}
              />
              <Route component={Login} {...this.props} />
            </Switch>
          </Router>
        </Provider>
      );
    }
    return (
      <Provider store={this.props.store}>
        <Router basename={process.env.REACT_APP_BASENAME || '/'}>
          <React.Fragment>
            <Navigation
              {...this.props}
              clearIntervalOnLogout={this.clearIntervalOnLogout}
            />
            {
              <DialogSessionWrapper
                appUser={this.props.appUser}
                logout={this.props.logout}
                getIntervalID={this.getIntervalID}
              />
            }

            <Switch>
              <Container id="contentContainer">
                <Sidebar appUser={this.props.appUser} />
                <Column>
                  <Bottom>
                    <Route
                      exact
                      path="/"
                      component={requireAuth(Dashboard, [])}
                      {...this.props}
                    />
                    <Route
                      exact
                      path="/reports"
                      component={requireAuth(Reports, [])}
                      {...this.props}
                    />
                    <Route
                      exact
                      path="/new"
                      component={requireAuth(VendorRequest, [
                        Permissions.CREATE_THIRD_PARTY_REQUESTS,
                      ])}
                      {...this.props}
                    />
                    <Route
                      exact
                      path="/manage-questionnaires"
                      component={requireAuth(QuestionnaireManagement, [
                        Permissions.CREATE_PRESCREENING_QUESTIONS,
                        Permissions.MODIFY_PRESCREENING_QUESTIONS,
                        Permissions.CREATE_QUESTIONNAIRE_QUESTIONS,
                        Permissions.MODIFY_QUESTIONNAIRE_QUESTIONS,
                      ])}
                      {...this.props}
                    />
                    <Route
                      exact
                      path="/admin-tools"
                      component={requireAuth(AdminManagement, [
                        Permissions.ADMIN_TOOLS,
                      ])}
                      {...this.props}
                    />
                    <Route
                      exact
                      path="/questionnaire/:id"
                      component={requireAuth(Questionnaire, [
                        Permissions.MODIFY_QUESTIONNAIRE,
                        Permissions.MODIFY_ANY_QUESTIONNAIRE,
                      ])}
                      {...this.props}
                    />
                    <Route
                      exact
                      path="/assessments"
                      component={requireAuth(ManageVendorRequests, [
                        Permissions.VIEW_THIRD_PARTY_REQUESTS,
                        Permissions.VIEW_ALL_THIRD_PARTY_REQUESTS,
                        Permissions.VIEW_OWNED_THIRD_PARTY_REQUESTS,
						Permissions.VIEW_DEPT_THIRD_PARTY_REQUESTS,
                      ])}
                      {...this.props}
                    />
                    <Route
                      exact
                      path="/assessments/:requestID"
                      component={requireAuth(ManageVendorRequest, [
                        Permissions.VIEW_THIRD_PARTY_REQUESTS,
                        Permissions.VIEW_ALL_THIRD_PARTY_REQUESTS,
                        Permissions.VIEW_OWNED_THIRD_PARTY_REQUESTS,
                        Permissions.MODIFY_OWNED_THIRD_PARTY_REQUESTS,
                        Permissions.MODIFY_ALL_THIRD_PARTY_REQUESTS,
						Permissions.VIEW_DEPT_THIRD_PARTY_REQUESTS,
                      ])}
                      {...this.props}
                    />
                    <Route
                      exact
                      path="/users"
                      component={requireAuth(ManageUsers, [
                        Permissions.VIEW_ALL_USERS,
                      ])}
                      {...this.props}
                    />
                    <Route
                      exact
                      path="/third-party-users"
                      component={requireAuth(ManageChildUsers, [
                        Permissions.VIEW_THIRD_PARTY_USER,
                        Permissions.VIEW_THIRD_PARTY_USER_FOR_THIRD_PARTY,
                      ])}
                      {...this.props}
                    />
                    <Route
                      exact
                      path="/manage-parties"
                      component={requireAuth(ManageVendors, [
                        Permissions.VIEW_THIRD_PARTY,
                      ])}
                      {...this.props}
                    />
                    <Route
                      exact
                      path="/auth-redirect"
                      component={AuthRedirect}
                      {...this.props}
                    />
                    <Route
                      exact
                      path="/manage-parties/:vendorID"
                      component={requireAuth(ManageVendorDetails, [
                        Permissions.VIEW_ALL_USERS,
                        Permissions.THIRD_PARTY_MANAGEMENT,
                      ])}
                      {...this.props}
                    />
                    <Route
                      exact
                      path="/renewals"
                      component={requireAuth(ManageRenewals, [
                        Permissions.RENEW_ALL_THIRD_PARTY_REQUESTS,
                        Permissions.RENEW_OWNED_THIRD_PARTY_REQUESTS,
                      ])}
                      {...this.props}
                    />
                    <Route
                      exact
                      path="/renewals/:vendorRequestID/:vendorID"
                      component={requireAuth(RenewalDetails, [
                        Permissions.RENEW_ALL_THIRD_PARTY_REQUESTS,
                        Permissions.RENEW_OWNED_THIRD_PARTY_REQUESTS,
                      ])}
                      {...this.props}
                    />
                  </Bottom>
                </Column>
              </Container>
            </Switch>
          </React.Fragment>
        </Router>
      </Provider>
    );
  }
}

const Container = styled.div`
  height: 100%;
  overflow: hidden;
  margin: 0px;
  display: flex;
  box-sizing: border-box;

  margin-top: 98px;
  position: relative;
  z-index: 0;
`;

const Bottom = styled.div`
  flex-grow: 1;
`;

const Column = styled.div`
  flex-grow: 1;
  padding: 3rem;
  overflow-y: auto;
  height: calc(100% - 100px);
  display: flex;
  flex-direction: column;

  @media screen and (max-width: 1400px) {
    padding: 3rem 0.5rem;
  }
`;

const mapStateToProps = state => ({
  isFetching: state.auth.isFetching,
  appUser: state.auth.appUser,
});

App = connect(
  mapStateToProps,
  actions
)(App);

export default App;
